module.exports = __webpack_public_path__ + "img/medium-biter-run.0fcff81f.png";